import hooks from './shipment-parses.hooks';
import createSchema from './shipment-parses.schema';

export default (app) => {
  const service = app.service('api/shipment-parses');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
